module.exports = __webpack_public_path__ + "img/brunch-menu-2026.4848c65f.jpg";